(function() {
    var root = document.getElementById("ca-ask"),
        configNode = document.getElementById("ca-ask-config");
    if (!root || !configNode) return;
    var config = {};
    try {
        config = JSON.parse(configNode.textContent || "{}")
    } catch {
        config = {}
    }
    var endpoint = typeof config.endpoint == "string" ? config.endpoint : "";
    if (!/^https:\/\//.test(endpoint)) return;
    var shopRoot = typeof config.shop == "string" ? config.shop.replace(/\/$/, "") : "",
        log = root.querySelector("[data-ask-log]"),
        form = root.querySelector("[data-ask-form]"),
        input = root.querySelector("[data-ask-input]"),
        examples = root.querySelector("[data-ask-examples]"),
        fileInput = root.querySelector("[data-ask-file]"),
        apiMessages = [],
        map = new Map,
        mapPromise = null,
        shopCache = new Map,
        busy = !1,
        pendingPhoto = null,
        UNAVAILABLE = "The product assistant is unavailable right now. You can still search the catalogue, or contact Creative Automation sales.",
        SLOW = "This is taking longer than usual, please try again or send a closer photo of the part code.";
    document.querySelectorAll("[data-zoho-id]").forEach(function(node) {
        var id = node.getAttribute("data-zoho-id"),
            url = node.getAttribute("href") || node.getAttribute("data-url");
        id && url && map.set(String(id), url)
    });

    function openPanel(seed) {
        root.hidden = !1, document.body.style.overflow = "hidden", typeof seed == "string" && (input.value = seed), input.focus()
    }

    function closePanel() {
        root.hidden = !0, document.body.style.overflow = ""
    }

    function queryFrom(node) {
        if (!node) return "";
        var explicit = node.getAttribute("data-ask-query");
        if (explicit) return explicit;
        var field = node.querySelector("[data-ask-seed]");
        return field && "value" in field ? field.value : ""
    }

    function eventElement(target) {
        return target ? target.nodeType === 1 ? target : target.parentElement : null
    }
    document.addEventListener("click", function(event) {
        var el = eventElement(event.target);
        if (el) {
            if (el.closest("[data-ask-chip]")) {
                var chip = el.closest("[data-ask-chip]");
                event.preventDefault(), send(chip.getAttribute("data-ask-chip") || "");
                return
            }
            var photoOpen = el.closest("[data-ask-photo-open]");
            if (photoOpen) {
                event.preventDefault(), openPanel("");
                var panelPhoto = root.querySelector("[data-ask-photo]");
                panelPhoto && panelPhoto.click();
                return
            }
            var queryNode = el.closest("[data-ask-query]");
            if (queryNode && !queryNode.matches("form")) {
                event.preventDefault();
                var query = queryNode.getAttribute("data-ask-query") || queryFrom(queryNode);
                openPanel(""), String(query).trim() && send(String(query).trim());
                return
            }
            var opener = el.closest("[data-ask-open]");
            if (opener && !opener.matches("form")) {
                event.preventDefault(), openPanel("");
                return
            }
            el.closest("[data-ask-close]") && closePanel()
        }
    }), document.addEventListener("submit", function(event) {
        var headerForm = event.target;
        if (!(!headerForm || !headerForm.hasAttribute || !headerForm.hasAttribute("data-ask-open"))) {
            var field = headerForm.querySelector("[data-ask-seed]") || headerForm.querySelector("input[name='ask']"),
                query = field ? String(field.value || "") : "";
            event.preventDefault(), field && (field.value = ""), openPanel(""), query.trim() && send(query.trim())
        }
    }, !0), document.addEventListener("keydown", function(event) {
        event.key === "Escape" && !root.hidden && closePanel()
    });

    function shopPath(path) {
        return shopRoot && path.charAt(0) === "/" ? shopRoot + path : path
    }

    function textOf(content) {
        return typeof content == "string" ? content : Array.isArray(content) ? content.filter(function(block) {
            return block && block.type === "text" && block.text
        }).map(function(block) {
            return block.text
        }).join(`
`) : ""
    }

    function earlierAskTurn(turn) {
        if (!turn || typeof turn.content == "string") return turn;
        var blocks = Array.isArray(turn.content) ? turn.content : [],
            photos = blocks.filter(function(block) {
                return block && block.type === "image"
            }).length,
            text = textOf(blocks);
        if (!photos) return text ? {
            role: turn.role,
            content: text
        } : turn;
        var note = photos === 1 ? "Photo sent earlier." : photos + " photos sent earlier.";
        return {
            role: turn.role,
            content: [text, note].filter(Boolean).join(`
`).slice(0, 500)
        }
    }

    function outgoingAskHistory(previous, userContent) {
        var older = (Array.isArray(previous) ? previous : []).map(earlierAskTurn);
        return older.concat([{
            role: "user",
            content: userContent
        }]).slice(-12)
    }

    function shopReply(text) {
        var shown = String(text || "").split(/(?<=[.!?])\s+/).filter(function(sentence) {
            return !/\b(request|other brands|on order|price on request|not in (?:our )?stock)\b/i.test(sentence)
        }).join(" ").trim();
        return shown || String(text || "").trim()
    }

    function formatAed(amount) {
        var negative = amount < 0,
            parts = Math.abs(amount).toFixed(2).split(".");
        return parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), (negative ? "-" : "") + "AED " + parts[0] + "." + parts[1]
    }

    function priceInc(product) {
        if (typeof product.priceIncVat == "number") return product.priceIncVat;
        if (typeof product.priceExVat != "number") return null;
        var vat = typeof product.vatPercentage == "number" ? product.vatPercentage : 5;
        return Math.round((product.priceExVat * (1 + vat / 100) + Number.EPSILON) * 100) / 100
    }

    function stockLabel(product) {
        if (typeof product.availability == "string" && product.availability.trim()) return product.availability.trim();
        if (typeof product.availableForSale != "number") return "";
        var qty = Math.abs(product.availableForSale - Math.round(product.availableForSale)) < 1e-9 ? String(Math.round(product.availableForSale)) : product.availableForSale.toFixed(1),
            unit = product.unit || "PCE",
            low = (unit === "PCE" || unit === "SET") && product.availableForSale < 5;
        return low ? "Only " + qty + " " + unit + " left" : qty + " " + unit + " available"
    }

    function pushInline(list, text, bold, italic) {
        if (text) {
            var last = list[list.length - 1];
            last && last.bold === bold && last.italic === italic ? last.text += text : list.push({
                text,
                bold,
                italic
            })
        }
    }

    function inlines(source) {
        for (var list = [], pattern = /\*\*([^*]+)\*\*|\*([^*\n]+)\*|_([^_\n]+)_/g, match, cursor = 0; match = pattern.exec(source);) match.index > cursor && pushInline(list, source.slice(cursor, match.index).replace(/\*\*/g, ""), !1, !1), match[1] != null ? pushInline(list, match[1], !0, !1) : pushInline(list, match[2] || match[3] || "", !1, !0), cursor = match.index + match[0].length;
        return cursor < source.length && pushInline(list, source.slice(cursor).replace(/\*\*/g, ""), !1, !1), list
    }

    function renderReply(text) {
        var wrap = document.createElement("div");
        return wrap.className = "ca-md", String(text || "").replace(/\r\n/g, `
`).split(`
`).forEach(function(line) {
            var bullet = line.match(/^\s*(?:[-•]|\*(?!\*))\s+(.*)$/),
                source = bullet ? bullet[1].trim() : line.trim();
            if (source) {
                var row = document.createElement("p");
                bullet && row.appendChild(document.createTextNode("\u2022 ")), inlines(source).forEach(function(part) {
                    var node = part.bold || part.italic ? document.createElement(part.bold ? "strong" : "em") : document.createTextNode(part.text);
                    (part.bold || part.italic) && (node.textContent = part.text), row.appendChild(node)
                }), wrap.appendChild(row)
            }
        }), wrap
    }

    function safePath(url) {
        if (typeof url != "string") return "";
        var path = url.split("?")[0];
        return path.indexOf("/products/") === 0 || path.indexOf("/collections/") === 0 ? url : ""
    }

    function loadZohoMap() {
        return mapPromise || (mapPromise = (async function() {
            var base = typeof config.mapUrl == "string" ? config.mapUrl : "";
            if (!base) return map;

            function grab(page) {
                return fetch(base + (base.indexOf("?") >= 0 ? "&" : "?") + "page=" + page, {
                    headers: {
                        accept: "application/json,text/plain,*/*"
                    }
                }).then(function(r) {
                    return r.ok ? r.text() : ""
                }).then(function(t) {
                    var d;
                    try {
                        d = JSON.parse(t)
                    } catch {
                        return null
                    }(d.items || []).forEach(function(item) {
                        item && item.id != null && item.url && map.set(String(item.id), item.url)
                    });
                    return d
                }).catch(function() {
                    return null
                })
            }
            var first = await grab(1),
                pages = Math.min(Number(first && first.pages) || 1, 150),
                next = 2;
            async function worker() {
                for (; next <= pages;) {
                    var p = next++;
                    await grab(p)
                }
            }
            await Promise.all([1, 2, 3, 4, 5, 6, 7, 8].map(worker));
            return map
        })(), mapPromise)
    }
    async function productHref(product) {
        var id = product && product.id != null ? String(product.id) : "";
        return id && map.has(id) || (await loadZohoMap(), id && map.has(id)) ? safePath(map.get(id)) : ""
    }

    function imageUrl(value) {
        return value ? typeof value == "string" ? value.indexOf("//") === 0 ? "https:" + value : value : value.url ? imageUrl(value.url) : value.src ? imageUrl(value.src) : "" : ""
    }

    function foldCode(value) {
        return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "")
    }

    function handleFrom(url) {
        var path = String(url || "").split("?")[0],
            match = path.match(/\/products\/([^/]+)\/?$/);
        return match ? decodeURIComponent(match[1]) : ""
    }

    function numericId(value) {
        var m = String(value == null ? "" : value).match(/(\d+)\s*$/);
        return m ? m[1] : ""
    }
    function exactVariant(body, keys) {
        var variants = body && Array.isArray(body.variants) ? body.variants : [];
        for (var k = 0; k < keys.length; k++) {
            var hit = variants.find(function(v) { return foldCode(v.sku) === keys[k] || foldCode(v.barcode) === keys[k] });
            if (hit) return hit
        }
        return null
    }
    async function shopifyMatch(product) {
        var none = { href: "", image: "", variantId: null };
        if (!product) return none;
        var serverVariant = numericId(product.variantId);
        if (serverVariant) {
            var sHref = safePath(product.url || "") || (product.handle ? "/products/" + encodeURIComponent(product.handle) : "");
            return { href: sHref, image: imageUrl(product.image), variantId: Number(serverVariant) }
        }
        var raw = [product.sku, product.mpn, product.ean], keys = [], codes = [];
        raw.forEach(function(v) { var t = String(v || "").trim(), f = foldCode(t); f && keys.indexOf(f) < 0 && (keys.push(f), codes.push(t)) });
        var cacheKey = "x:" + (product.id != null ? product.id : "") + ":" + keys.join("|");
        if (shopCache.has(cacheKey)) return shopCache.get(cacheKey);
        var bodies = new Map;
        async function loadProduct(handle) {
            if (!handle) return null;
            if (bodies.has(handle)) return bodies.get(handle);
            var body = null;
            try {
                var r = await fetch(shopPath("/products/" + encodeURIComponent(handle) + ".js"), { headers: { accept: "application/json" } });
                body = r.ok ? await r.json().catch(function() { return null }) : null
            } catch { body = null }
            body = body && Array.isArray(body.variants) ? body : null;
            bodies.set(handle, body); return body
        }
        function pack(body, variant) {
            return { href: "/products/" + body.handle, image: imageUrl(variant.featured_image || body.featured_image || body.images && body.images[0]), variantId: variant.id }
        }
        var found = null;
        for (var c = 0; c < codes.length && !found; c++) {
            var suggest = null;
            try {
                suggest = await fetch(shopPath("/search/suggest.json?q=" + encodeURIComponent(codes[c]) + "&resources[type]=product&resources[limit]=8&resources[options][fields]=title,variants.sku,variants.barcode,vendor"), { headers: { accept: "application/json" } }).then(function(r) { return r.ok ? r.json() : null })
            } catch { suggest = null }
            var list = suggest && suggest.resources && suggest.resources.results && suggest.resources.results.products || [];
            for (var i = 0; i < list.length && i < 6 && !found; i++) {
                var body = await loadProduct(list[i].handle), v = exactVariant(body, keys);
                v && (found = pack(body, v))
            }
            if (!found) {
                var guess = codes[c].toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""), gb = await loadProduct(guess), gv = exactVariant(gb, keys);
                gv && (found = pack(gb, gv))
            }
        }
        if (!found) {
            found = { href: "", image: "", variantId: null };
            var byId = await productHref(product);
            if (byId) {
                var mb = await loadProduct(handleFrom(byId)), mv = exactVariant(mb, keys);
                found = mv ? pack(mb, mv) : { href: byId, image: mb ? imageUrl(mb.featured_image) : "", variantId: null }
            }
        }
        shopCache.set(cacheKey, found);
        return found
    }

    function refreshCartCount() {
        return fetch(shopPath("/cart.js"), {
            headers: {
                accept: "application/json"
            }
        }).then(function(response) {
            return response.ok ? response.json() : null
        }).then(function(cart) {
            cart && document.querySelectorAll("[data-cart-count]").forEach(function(node) {
                var count = cart.item_count || 0;
                node.textContent = count > 99 ? "99" : String(count), node.hidden = count < 1
            })
        }).catch(function() {})
    }
    function readFile(file) {
        return new Promise(function(resolve, reject) {
            var reader = new FileReader;
            reader.onload = function() {
                resolve(String(reader.result || ""))
            }, reader.onerror = reject, reader.readAsDataURL(file)
        })
    }

    function readNdjson(response, onEvent) {
        if (!response.body || !response.body.getReader) return response.text().then(function(text) {
            return parseNdjsonText(text, onEvent)
        });
        var reader = response.body.getReader(),
            decoder = new TextDecoder,
            buffer = "",
            result = null;

        function consume(line) {
            var trimmed = String(line || "").trim();
            if (trimmed) {
                var event;
                try {
                    event = JSON.parse(trimmed)
                } catch {
                    return
                }
                onEvent && onEvent(event), event && event.type === "result" && (result = event), event && event.type === "error" && (result = {
                    error: event.error || UNAVAILABLE
                })
            }
        }

        function pump() {
            return reader.read().then(function(step) {
                if (step.done) return buffer.trim() && consume(buffer), result;
                buffer += decoder.decode(step.value, {
                    stream: !0
                });
                var lines = buffer.split(`
`);
                return buffer = lines.pop(), lines.forEach(consume), pump()
            })
        }
        return pump()
    }

    function parseNdjsonText(text, onEvent) {
        var result = null;
        return String(text || "").split(`
`).forEach(function(line) {
            var trimmed = line.trim();
            if (trimmed) {
                var event;
                try {
                    event = JSON.parse(trimmed)
                } catch {
                    return
                }
                onEvent && onEvent(event), event && event.type === "result" && (result = event), event && event.type === "error" && (result = {
                    error: event.error || UNAVAILABLE
                })
            }
        }), result
    }

    function replyFrom(payload) {
        return !payload || typeof payload != "object" ? "" : typeof payload.reply == "string" ? payload.reply : payload.result && typeof payload.result.reply == "string" ? payload.result.reply : ""
    }
    /* ---- Creative App Ask AI (ask.tsx) mirrored for the web ---- */
    var CLOSE_PEEK = 1.2, CLOSE_GAP = 10, GROUP_GAP = 12, PAGE = 20;
    var ENGLISH = new Set("a an the of to for and or way on in by as at is it up air bar set new low pin top end not all two one box nut rod cap oil gas kit arm from into over with".split(" "));
    var addedIds = {}, cartVariants = new Set, live = false, typing = null, threadCount = 0;
    var newChatBtn = root.querySelector("[data-ask-new]"), sendBtn = root.querySelector("[data-ask-send]"), photoButton = root.querySelector("[data-ask-photo]");
    var choices = root.querySelector("[data-ask-choices]"), preview = root.querySelector("[data-ask-preview]");
    var previewImg = preview ? preview.querySelector("img") : null, previewRemove = root.querySelector("[data-ask-preview-remove]");

    function el(tag, cls, text) {
        var node = document.createElement(tag);
        if (cls) node.className = cls;
        if (text != null) node.textContent = text;
        return node
    }
    function cleanLine(value) { return String(value || "").replace(/\bbest fit\b/gi, "").replace(/\s+/g, " ").trim() }
    function appShopReply(text) {
        return String(text || "").split(/(?<=[.!?])\s+/).filter(function(s) { return !/\b(request|other brands|on order|price on request|not in (?:our )?stock)\b/i.test(s) }).join(" ").trim()
    }
    function shownReply(m) {
        var lead = cleanLine(m.lead);
        if (lead) return lead;
        return String(m.text || "").split(/(?<=[.!?])\s+/).filter(function(s) { return !/\bbest fit\b/i.test(s) }).join(" ").trim()
    }
    function readableName(value) {
        var text = String(value || "").replace(/\s+/g, " ").trim(), letters = text.replace(/[^A-Za-z]/g, "");
        if (!letters) return text;
        if ((letters.match(/[A-Z]/g) || []).length / letters.length < .7) return text;
        return text.split(" ").map(function(t) {
            if (/\d/.test(t)) return t;
            if (!/^[A-Za-z][A-Za-z'+-]*$/.test(t) || t !== t.toUpperCase()) return t;
            var lower = t.toLowerCase();
            if (t.length <= 3 && !ENGLISH.has(lower)) return t;
            return lower.charAt(0).toUpperCase() + lower.slice(1)
        }).join(" ")
    }
    function inStockLabel(item) {
        var q = item.availableForSale;
        return isFinite(q) && q > 0 && Math.abs(q - Math.round(q)) < .001 ? Math.round(q) + " in stock" : "In stock"
    }
    function brandSku(item) { return [item.brand, item.sku].filter(Boolean).join(" \u00B7 ") }
    function availability(item) {
        var q = item.availableForSale, unit = item.unit || "PCE", n = Math.abs(q - Math.round(q)) < 1e-9 ? String(Math.round(q)) : q.toFixed(1);
        var low = (unit === "PCE" || unit === "SET") && q < 5;
        return { label: low ? "Only " + n + " " + unit + " left" : n + " " + unit + " available", low: low }
    }
    function stocked(item) { return item && item.availableForSale > 0 && item.priceExVat > 0 }
    function scrollEnd() { log.scrollTop = log.scrollHeight }
    function setBusy(next) {
        busy = next;
        root.classList.toggle("is-busy", busy);
        input.disabled = busy;
        photoButton && (photoButton.disabled = busy);
        root.querySelectorAll("[data-ask-chip]").forEach(function(b) { b.disabled = busy });
        syncSend()
    }
    function syncSend() { sendBtn && (sendBtn.disabled = busy || (!input.value.trim() && !pendingPhoto)) }
    input.addEventListener("input", syncSend);

    function loadCart() {
        return fetch(shopPath("/cart.js"), { headers: { accept: "application/json" } }).then(function(r) { return r.ok ? r.json() : null }).then(function(cart) {
            cartVariants = new Set((cart && cart.items || []).map(function(line) { return String(line.variant_id) }))
        }).catch(function() {})
    }

    function bubble(role, opts) {
        var wrap = el("div", role === "user" ? "ca-wrap ca-wrap--user" : "ca-wrap ca-wrap--ai");
        if (opts.photo) { var ph = el("div", "ca-chat-photo"), im = el("img"); im.src = opts.photo; im.alt = ""; ph.appendChild(im); wrap.appendChild(ph) }
        if (opts.text || opts.hint) {
            var b = el("div", "ca-bubble " + (role === "user" ? "ca-bubble--user" : "ca-bubble--ai") + (opts.error ? " ca-bubble--error" : ""));
            if (opts.text) b.appendChild(role === "user" ? el("p", "ca-t-body ca-t-user", opts.text) : opts.meta ? el("p", "ca-t-meta", opts.text) : renderReply(opts.text));
            if (opts.hint) b.appendChild(el("p", "ca-t-meta", opts.hint));
            wrap.appendChild(b)
        }
        log.appendChild(wrap); threadCount += 1; scrollEnd();
        return wrap
    }

    function photoBox(item, cls, grouped, shopP) {
        var box = el("a", cls);
        box.setAttribute("aria-label", item.name || item.sku || "Part");
        var fill = el("span", "ca-photo-fill");
        var letter = String(item.brand || item.name || "").trim().charAt(0).toUpperCase();
        var tile = el("span", "ca-letter", /^[A-Z0-9]$/.test(letter) ? letter : "?");
        fill.appendChild(tile); box.appendChild(fill);
        if (grouped) { var badge = el("span", "ca-photo-badge"); badge.appendChild(el("span", "ca-stock-pill", inStockLabel(item))); box.appendChild(badge) }
        shopP.then(function(shop) {
            if (shop.image) { var img = el("img"); img.src = shop.image; img.alt = ""; img.loading = "lazy"; fill.replaceChild(img, tile) }
        });
        return box
    }
    function linkUp(nodes, shopP) {
        shopP.then(function(shop) {
            if (!shop.href) return;
            var href = shop.href.charAt(0) === "/" ? shopPath(shop.href.split("?")[0]) : shop.href;
            nodes.forEach(function(n) { n.href = href; n.classList.add("is-link") })
        })
    }
    function addButton(item, shopP) {
        var btn = el("button", "ca-outline-add");
        btn.type = "button"; btn.disabled = true;
        var label = el("span", "ca-outline-label", "Add to cart"); btn.appendChild(label);
        shopP.then(function(shop) {
            if (!shop.variantId) { btn.remove(); return }
            btn.setAttribute("data-variant-id", String(shop.variantId));
            if (addedIds[item.id] || cartVariants.has(String(shop.variantId))) label.textContent = "Added";
            btn.disabled = false;
            btn.addEventListener("click", function() {
                btn.disabled = true;
                fetch(shopPath("/cart/add.js"), { method: "POST", headers: { "content-type": "application/json", accept: "application/json" }, body: JSON.stringify({ id: shop.variantId, quantity: 1 }) }).then(function(r) {
                    if (r.ok) { addedIds[item.id] = true; cartVariants.add(String(shop.variantId)); label.textContent = "Added"; refreshCartCount() }
                    else return r.json().catch(function() { return null }).then(function(body) {
                        var msg = body && (body.description || body.message) || "";
                        if (msg) bubble("assistant", { text: msg, error: true })
                    })
                }).catch(function() {}).then(function() { btn.disabled = false })
            })
        });
        return btn
    }
    function priceText(item) { var a = priceInc(item); return a == null ? "" : formatAed(a) }

    function stockCard(item, o) {
        var shopP = shopifyMatch(item);
        var card = el("div", "ca-card ca-stock-card" + (o.grouped ? " is-grouped" : ""));
        var photo = photoBox(item, "ca-stock-photo", o.grouped, shopP); card.appendChild(photo);
        var copy = el("div", "ca-stock-copy"), text = el("a", "ca-stock-text");
        if (!o.grouped && o.badge) text.appendChild(el("span", "ca-t-good", o.badge));
        text.appendChild(el("span", "ca-t-bodyMedium ca-clamp2", o.grouped ? readableName(item.name) : item.name));
        if (o.grouped) text.appendChild(el("span", "ca-t-meta ca-clamp1", brandSku(item)));
        else { var row = el("span", "ca-meta-row"); item.brand && row.appendChild(el("span", "ca-t-meta", item.brand)); row.appendChild(el("span", "ca-t-mono", item.sku)); text.appendChild(row) }
        if (o.grouped && o.difference) { var pill = el("span", "ca-diff-pill"); pill.appendChild(el("span", "ca-t-warn", o.difference)); text.appendChild(pill) }
        text.appendChild(el("span", "ca-t-priceLarge ca-stock-price", priceText(item)));
        text.appendChild(el("span", "ca-t-meta", "incl. VAT"));
        if (!o.grouped) { var s = availability(item); text.appendChild(el("span", s.low ? "ca-t-warn" : "ca-t-good", s.label)) }
        copy.appendChild(text); copy.appendChild(addButton(item, shopP)); card.appendChild(copy);
        linkUp([photo, text], shopP);
        return card
    }
    function closeCard(item, o) {
        var shopP = shopifyMatch(item);
        var card = el("div", "ca-carousel-card" + (o.grouped ? " is-grouped" : ""));
        card.style.width = o.width + "px";
        var photo = photoBox(item, o.grouped ? "ca-grouped-photo" : "ca-carousel-photo", o.grouped, shopP); card.appendChild(photo);
        var body = el("div", "ca-carousel-body"), text = el("a", "ca-stock-text");
        text.appendChild(el("span", "ca-t-bodyMedium ca-clamp2 " + (o.grouped ? "ca-grouped-name" : "ca-carousel-name"), o.grouped ? readableName(item.name) : item.name));
        text.appendChild(el("span", (o.grouped ? "ca-t-meta" : "ca-t-mono") + " ca-clamp1", o.grouped ? brandSku(item) : item.sku));
        if (o.grouped && o.difference) { var pill = el("span", "ca-diff-pill"); pill.appendChild(el("span", "ca-t-warn", o.difference)); text.appendChild(pill) }
        text.appendChild(el("span", "ca-t-priceLarge " + (o.grouped ? "ca-grouped-price" : "ca-carousel-price"), priceText(item)));
        text.appendChild(el("span", "ca-t-meta", "incl. VAT"));
        if (!o.grouped) { var s = availability(item); text.appendChild(el("span", s.low ? "ca-t-warn" : "ca-t-good", s.label)) }
        body.appendChild(text); body.appendChild(addButton(item, shopP)); card.appendChild(body);
        linkUp([photo, text], shopP);
        return card
    }
    function groupCols() { return available() >= 540 ? 3 : 2 }
    function available() { return Math.max(0, log.clientWidth - PAGE * 2) }
    function carousel(items, o) {
        var host = el("div", "ca-carousel"), w = available();
        var width = o.grouped ? Math.max(140, Math.round((w - GROUP_GAP * (groupCols() - 1)) / groupCols())) : items.length <= 1 ? Math.round(w) : Math.max(160, Math.round(w / CLOSE_PEEK));
        var gap = o.grouped ? GROUP_GAP : CLOSE_GAP, paged = o.grouped ? items.length > groupCols() : items.length > 1;
        var row = el("div", "ca-carousel-row"); row.style.gap = gap + "px";
        items.forEach(function(item) { row.appendChild(closeCard(item, { grouped: o.grouped, width: width, difference: o.grouped ? (o.notes || {})[item.id] || "" : "" })) });
        host.appendChild(row);
        if (paged) {
            var dots = el("div", "ca-dots"), list = items.map(function(_, i) { var d = el("span", "ca-dot" + (i === 0 ? " is-on" : "")); dots.appendChild(d); return d });
            row.addEventListener("scroll", function() {
                var page = Math.min(items.length - 1, Math.max(0, Math.round(row.scrollLeft / (width + gap))));
                list.forEach(function(d, i) { d.classList.toggle("is-on", i === page) })
            }, { passive: true });
            host.appendChild(dots)
        }
        return host
    }
    function renderAnswer(m) {
        var answer = el("div", "ca-answer");
        var groups = (m.groups || []).map(function(g) {
            var cards = (g.products || []).filter(stocked).map(function(p) { return { item: p, note: cleanLine(p.note) } });
            return { title: cleanLine(g.title), subtitle: cleanLine(g.subtitle), link: cleanLine(g.link), cards: cards }
        }).filter(function(g) { return g.title && g.cards.length });
        if (groups.length) {
            var gw = el("div", "ca-groups");
            groups.forEach(function(g) {
                var box = el("div", "ca-group");
                g.link && box.appendChild(el("p", "ca-t-body", g.link));
                box.appendChild(el("p", "ca-group-title ca-clamp2", g.title));
                g.subtitle && box.appendChild(el("p", "ca-t-meta ca-clamp2", g.subtitle));
                if (g.cards.length === 1) box.appendChild(stockCard(g.cards[0].item, { grouped: true, difference: g.cards[0].note }));
                else { var notes = {}; g.cards.forEach(function(c) { notes[c.item.id] = c.note }); box.appendChild(carousel(g.cards.map(function(c) { return c.item }), { grouped: true, notes: notes })) }
                gw.appendChild(box)
            });
            answer.appendChild(gw)
        } else if (!m.error) {
            var items = (m.products || []).filter(stocked), exact = [], close = [];
            if (m.stockFit === "exact") exact = items; else if (m.stockFit === "close") close = items;
            var looking = /^(exact|close|loose|none)$/.test(String(m.stockFit || ""));
            if (!exact.length && !close.length) { looking && answer.appendChild(el("p", "ca-t-meta", "Nothing in stock matches that part.")) }
            else {
                var wrap = el("div");
                if (exact.length) { var sec = el("div", "ca-section"); sec.appendChild(el("p", "ca-t-section", "Exact part")); exact.forEach(function(it) { sec.appendChild(stockCard(it, { badge: "In stock" })) }); wrap.appendChild(sec) }
                if (close.length) { var sec2 = el("div", "ca-section"); sec2.appendChild(el("p", "ca-t-section", close.length > 1 ? "Close alternatives" : "Close alternative")); sec2.appendChild(carousel(close, {})); wrap.appendChild(sec2) }
                answer.appendChild(wrap)
            }
        }
        var question = cleanLine(m.question);
        question && answer.appendChild(el("p", "ca-t-body", question));
        var chips = (m.chips || []).map(cleanLine).filter(Boolean).slice(0, 3);
        if (chips.length) {
            var row = el("div", "ca-chip-row");
            chips.forEach(function(c) { var b = el("button", "ca-reply-chip"); b.type = "button"; b.setAttribute("data-ask-chip", c); b.appendChild(el("span", "ca-reply-chip-text", c)); b.disabled = busy; row.appendChild(b) });
            answer.appendChild(row)
        }
        return answer
    }

    function clearPhoto() { pendingPhoto = null; preview && (preview.hidden = true); previewImg && previewImg.removeAttribute("src"); syncSend() }
    function showPhoto(photo) { pendingPhoto = photo; previewImg.src = photo.previewUri; preview.hidden = false; choices && (choices.hidden = true); syncSend() }
    previewRemove && previewRemove.addEventListener("click", clearPhoto);
    var steps = null;
    function showTyping() {
        var t0 = Date.now(), wrap = el("div", "ca-wrap ca-wrap--ai ca-steps-wrap"), b = el("div", "ca-bubble ca-bubble--ai ca-steps");
        var head = el("button", "ca-steps-head"); head.type = "button"; head.disabled = true; head.setAttribute("aria-expanded", "true");
        var label = el("span", "ca-t-meta ca-steps-label", "Checking the catalogue\u2026"); head.appendChild(label);
        var caret = el("span", "ca-t-meta ca-steps-caret", "\u203a"); head.appendChild(caret);
        var list = el("ul", "ca-steps-list"); b.appendChild(head); b.appendChild(list); wrap.appendChild(b);
        var skel = el("div", "ca-wrap ca-wrap--ai ca-skel-wrap"), row = el("div", "ca-carousel-row ca-skel-row"), w = available(), cols = groupCols(), cw = Math.max(140, Math.round((w - GROUP_GAP * (cols - 1)) / cols));
        row.style.gap = GROUP_GAP + "px";
        for (var i = 0; i < cols; i++) { var c = el("div", "ca-carousel-card is-grouped ca-skel-card"); c.style.width = cw + "px"; c.appendChild(el("div", "ca-grouped-photo ca-skel ca-skel-photo")); var bd = el("div", "ca-carousel-body"); ["ca-skel-l1", "ca-skel-l2", "ca-skel-l3", "ca-skel-btn"].forEach(function(k) { bd.appendChild(el("div", "ca-skel " + k)) }); c.appendChild(bd); row.appendChild(c) }
        skel.appendChild(row); skel.setAttribute("aria-hidden", "true");
        log.appendChild(wrap); log.appendChild(skel);
        steps = { t0: t0, wrap: wrap, head: head, label: label, list: list, skel: skel, seen: {} };
        head.addEventListener("click", function() { var open = head.getAttribute("aria-expanded") !== "true"; head.setAttribute("aria-expanded", String(open)); list.hidden = !open; scrollEnd() });
        typing = wrap; scrollEnd()
    }
    function addStep(text) {
        if (!steps || steps.seen[text]) return; steps.seen[text] = 1;
        var prev = steps.list.querySelector(".is-now"); prev && prev.classList.remove("is-now");
        steps.list.appendChild(el("li", "ca-t-meta ca-step is-now", text));
        log.insertBefore(steps.wrap, steps.skel); scrollEnd()
    }
    function hideTyping(keep) {
        if (!steps) { typing && typing.remove(); typing = null; return }
        steps.skel.remove();
        var n = steps.list.children.length;
        if (!keep || !n) steps.wrap.remove();
        else { var cur = steps.list.querySelector(".is-now"); cur && cur.classList.remove("is-now"); steps.label.textContent = "Searched for " + Math.max(1, Math.round((Date.now() - steps.t0) / 1e3)) + "s"; steps.head.disabled = false; steps.head.setAttribute("aria-expanded", "false"); steps.list.hidden = true; steps.wrap.classList.add("is-done") }
        steps = null; typing = null
    }

    async function send(text, photo) {
        var query = String(text || "").trim().slice(0, 500), shot = photo || null;
        if (busy || (!query && !shot)) return;
        var userContent = shot ? [].concat(query ? [{ type: "text", text: query }] : [], [{ type: "image", source: { type: "base64", media_type: shot.mediaType, data: shot.data } }]) : query;
        var history = outgoingAskHistory(apiMessages, userContent);
        apiMessages = apiMessages.concat([{ role: "user", content: query || "Photo sent." }]).slice(-12);
        examples && (examples.hidden = true);
        bubble("user", { text: query, photo: shot && shot.previewUri });
        input.value = ""; clearPhoto(); choices && (choices.hidden = true);
        setBusy(true); live = false; showTyping(); loadCart();
        var controller = new AbortController, timer = window.setTimeout(function() { controller.abort() }, 75e3), payload = null, response = null;
        try {
            response = await fetch(endpoint, { method: "POST", headers: { "content-type": "application/json", accept: "application/x-ndjson, application/json" }, body: JSON.stringify({ messages: history, stream: true }), signal: controller.signal });
            var ctype = (response.headers.get("content-type") || "").toLowerCase();
            if (response.status !== 429 && ctype.indexOf("ndjson") !== -1) {
                payload = await readNdjson(response, function(event) {
                    if (!event || event.type !== "progress" || !event.text) return;
                    live = true; addStep(String(event.text).trim())
                })
            } else payload = await response.json().catch(function() { return null });
            hideTyping(true);
            if (response.status === 429) { bubble("assistant", { text: payload && payload.error || "Too many questions from this network. Wait a few minutes and try again.", error: true }); return }
            var reply = replyFrom(payload);
            if (!response.ok || !reply) { bubble("assistant", { text: payload && payload.error || UNAVAILABLE, error: true }); return }
            if (payload.result && typeof payload.result === "object" && !payload.groups) payload = payload.result;
            var m = { text: appShopReply(reply), readHint: typeof payload.readHint === "string" ? payload.readHint.trim() : "", lead: payload.lead, question: payload.question, chips: Array.isArray(payload.chips) ? payload.chips : [], groups: Array.isArray(payload.groups) ? payload.groups : [], products: Array.isArray(payload.products) ? payload.products : [], stockFit: payload.stockFit };
            apiMessages = apiMessages.concat([{ role: "assistant", content: reply }]).slice(-12);
            var wrap = bubble("assistant", { text: shownReply(m), hint: m.readHint });
            wrap.appendChild(renderAnswer(m));
            scrollEnd()
        } catch (error) {
            hideTyping();
            bubble("assistant", { text: error && error.name === "AbortError" ? SLOW : UNAVAILABLE, error: true })
        } finally {
            window.clearTimeout(timer); setBusy(false); live = false; scrollEnd()
        }
    }
    function resetChat() {
        log.querySelectorAll(".ca-wrap").forEach(function(n) { n.remove() });
        apiMessages = []; addedIds = {}; threadCount = 0; input.value = ""; clearPhoto(); choices && (choices.hidden = true);
        examples && (examples.hidden = false); log.scrollTop = 0
    }
    newChatBtn && newChatBtn.addEventListener("click", function() {
        if (!threadCount) { resetChat(); return }
        if (window.confirm("Start a new chat?\n\nThis clears the current conversation.")) resetChat()
    });
    form && form.addEventListener("submit", function(event) { event.preventDefault(); send(input.value, pendingPhoto) });
    root.querySelectorAll("[data-ask-example]").forEach(function(button) { button.addEventListener("click", function() { send(button.getAttribute("data-ask-example"), null) }) });
    var take = root.querySelector("[data-ask-take]"), upload = root.querySelector("[data-ask-upload]");
    photoButton && fileInput && choices && (photoButton.addEventListener("click", function() { choices.hidden = !choices.hidden }), take.addEventListener("click", function() {
        fileInput.setAttribute("capture", "environment"); fileInput.click()
    }), upload.addEventListener("click", function() {
        fileInput.removeAttribute("capture"); fileInput.click()
    }), fileInput.addEventListener("change", async function() {
        var file = fileInput.files && fileInput.files[0];
        fileInput.value = "";
        if (!file) return;
        var dataUrl = await readFile(file), data = dataUrl.split(",")[1] || "", bytes = Math.floor(data.length * 3 / 4);
        var type = file.type === "image/png" || file.type === "image/webp" ? file.type : "image/jpeg";
        if (!data) { bubble("assistant", { text: "Could not read that photo.", error: true }); return }
        if (bytes > 5 * 1024 * 1024) { bubble("assistant", { text: "That photo is still too large. Use a smaller photo of the label.", error: true }); return }
        showPhoto({ mediaType: type, data: data, previewUri: dataUrl })
    }));
    syncSend();
    config.open === true && openPanel("");
    var searchQueryNode = document.getElementById("ca-search-query"), initialQuery = "";
    if (searchQueryNode) try { var parsed = JSON.parse(searchQueryNode.textContent || "null"); typeof parsed == "string" && (initialQuery = parsed) } catch (e) { initialQuery = "" }
    !String(initialQuery).trim() && typeof URLSearchParams < "u" && (initialQuery = new URLSearchParams(window.location.search).get("ask") || "");
    var headerSeed = document.querySelector(".tm-search [data-ask-seed]");
    headerSeed && String(initialQuery).trim() && (headerSeed.value = String(initialQuery));
    document.body.classList.contains("template-search") && (openPanel(""), String(initialQuery).trim() && send(String(initialQuery).trim()))
})();
